import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import VueGtag from 'vue-gtag';
import router from '@/ui/router';
import i18n from '@/ui/i18n';

const { locale } = i18n;
const isProduction = process.env.NODE_ENV === 'prod';
try {
  if (isProduction) {
    Vue.use(VueGtm, {
      id: process.env[`VUE_APP_GOOGLE_TAG_MANAGER_ID_${locale}`],
      debug: false,
      vueRouter: router
    });

    Vue.use(VueGtag, {
      config: { id: process.env[`VUE_APP_ANALYTICS_ID_${locale}`] }
    }, router);
  }
} catch (e) {
  // eslint-disable-next-line no-console
  console.log(e);
}
